export default __webpack_public_path__ + "static/media/interaksi_belajar.9298de21.svg";